import { animationTransition } from '@shared/utils/animationTransition';
import { Box, styled } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const DesktopContainer = styled(Box)``;

const desktopContainerStyles: CSSObject = {
  width: 160,
  height: 6,
  ['& *']: { cursor: 'pointer !important' },
  ['> div']: { backgroundColor: 'transparent' },
  ['& input']: {
    padding: '0 28px 0 0 !important',
    minHeight: 0,
    fontWeight: 600,
    color: '#333333',
    backgroundColor: 'transparent',
    textAlign: 'right',
    transition: animationTransition('color'),
    _hover: {
      color: 'primary6',
    },
  },
  ['& span']: {
    margin: 0,
    minHeight: 0,
  },
  ['& button']: {
    padding: 0,
  },
  ['& ul']: {
    padding: 3,
    width: 224,
  },
  ['& li span']: {
    fontWeight: 400,
    color: '#333333',
  },
};

export const styles = {
  desktopContainer: desktopContainerStyles,
};
